import React, { useEffect, useMemo, useRef, useState } from "react";

export default function VideoLandingPage() {
  const videoRef = useRef(null);
  const [isBlurred, setIsBlurred] = useState(false);
  const [hasGated, setHasGated] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const POP_URL = "https://phoampor.top/4/9210289?data1=[CAMPAIGNNAME]-[WEBSITEID]-[CATEGORYID]-[QUALITY]-[BID]-[IMPRESSIONID]-[ADBLOCK]-[IPV6OR4]-[COUNTRY]-[FORMFACTORNAME]-[DEVICENAME]";

  const { mode, startT } = useMemo(() => {
    const q = new URLSearchParams(window.location.search);
    return {
      mode: q.get("mode") || "",
      startT: parseFloat(q.get("time") || "0"),
    };
  }, []);

  useEffect(() => {
    if (mode !== "video") return;
    const vid = videoRef.current;
    if (!vid) return;

    const onMeta = () => {
      vid.currentTime = startT;
      vid.pause();
      setIsBlurred(false);
      setHasGated(false);
      vid.removeEventListener("loadedmetadata", onMeta);
    };

    if (vid.readyState >= 1) {
      onMeta();
    } else {
      vid.addEventListener("loadedmetadata", onMeta);
    }
  }, [mode, startT]);

  // Sync play/pause state to React
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    vid.addEventListener("play", handlePlay);
    vid.addEventListener("pause", handlePause);
    return () => {
      vid.removeEventListener("play", handlePlay);
      vid.removeEventListener("pause", handlePause);
    };
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    const vid = videoRef.current;
    if (!vid) return;

    const spawnAndRedirect = (time) => {
      const url = `${window.location.origin}${window.location.pathname}?mode=video&time=${time}`;
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => {
        const a = document.createElement("a");
        a.href = POP_URL;
        a.rel = "noreferrer";
        a.target = "_self";
        document.body.appendChild(a);
        a.click();
      }, 50);
    };

    if (mode === "video") {
      if (!hasGated) {
        vid.play().catch(console.error);
        setTimeout(() => {
          vid.pause();
          setIsBlurred(true);
          setHasGated(true);
        }, 2000);
      } else {
        const now = vid.currentTime.toFixed(3);
        spawnAndRedirect(now);
      }
    } else {
      spawnAndRedirect("0.000");
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <video
        ref={videoRef}
        src="https://amplifybucket13203024424.s3.us-east-1.amazonaws.com/vid.mp4?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEIv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJIMEYCIQCZPTDAi2n6j%2FQNscQC9b1DnmCRp3BimiUWzI9tjz9fvgIhAOQsp%2F%2Bf6HNBA4ujJKjZjXllCt8nVzo1GF8QFu6X87aRKrkDCCQQARoMMzA0OTQ3NzM2ODU5Igwl%2BhaBKiFb%2Fpc9EdUqlgPypQomB%2BExL1SniEXYUS2D7onBF7lGSPP16UsNLI6EvMO25WYVrSh5yy%2Fdc2eJoyaxASgl3%2FDgNo9f8hUDD4ph1ZKEr2yXwtSTOw1OHySwghh%2FLzl8a0XYfyuUkZXIPPZtRMN9LGRa0jHqKhaO5NqggAe96OGOf32Vk%2FpHIreL565ygF7ul6kFmLYJK%2Bs6VdlbmQQvU2I7Mx%2FZDajUHoO8icmA4IIIckYHtw9hOA5mkiZdi3Z%2FgKc%2FhbKc16rrVcS99mhIUHw14jDQh2Ojg1SVIakeFnlzz1hWn7ODfKe0EgqkejcDFUgwKo%2FIRrOaDnmCmqvGKEQdzNzExcv2PHHZsOmgUJWrOTXigU6XMKUtXchnK0LokmPQar9SFEcF8%2B1nCwfUV9pxkoAeCv2l5L29XtiWx5vuJ91fx2URWRYA6%2Bsuo5MlwOGy%2BJt141H9HLwXS2MlMCVRXjCxdX%2BAcfI8crHINidpiPFHmKn8wzYIejO41ki2iVQGB3eVkJvH3vJI62XolFOHzuOplv74X%2FyrCVIy6uaTMKPsq8AGOt0CzNrgKYQYOwg%2Ba6kbBovBiMTYimQJbpE%2Bso4EXZpvYHi6wZyJP2s4Y%2B5GAGkcE23U3PUBEFUsFvdall4awOzhmrmdjxyunUzA%2F2bZA%2BO%2FgylJ9mccV2eId4J58zbUGDHJiH8gakx2kXYWuZxKo%2BGTg3flx4%2B1U%2FbnlujVNySEu7p0KeYQYGvEIEuD2odda%2FEq4nVl1e4AbbfNq9ljF449XnuuxatwiQ2F5X8oG1o6A5bJ3C%2BB0BAtKcfF4ADV%2BLdp4%2FAUe3vLPQkJ6xOm51iLJosfBojwjODC7xV3GO0lYRbKf7igSzrMJDO%2B4iTnaDYqReFvePXkTTUEunKAfVMQC30G0aO35m22n9eZWB78Hm2sC3bG%2ByBzUMTsbZ3%2BjTrFCWrdJHNrXeMM5LA57iol2hng%2F06YQT8W73%2FdXBxrPAaJjl0j9LMQoWGboIkEVJguzIHbQO9oy%2BuW9ZdKxw%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAUOACNGENTXEG3EG5%2F20250425%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250425T024648Z&X-Amz-Expires=43200&X-Amz-SignedHeaders=host&X-Amz-Signature=93f1635ee41a59ab9a4d460e0ae698200ae208d5cec5a8829575f5579b57cc6b"
        muted
        playsInline
        preload="auto"
        style={{
          height: '100vh',
          width: 'auto',
          objectFit: 'contain',
          filter: isBlurred && !isPlaying ? 'blur(8px)' : 'none',
          transition: 'filter 0.1s ease-out',
        }}
      />

      {!isPlaying && (
        <div
          onClick={handleClick}
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
        >
          <button
            style={{
              padding: 0,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon points="5,3 19,12 5,21" fill="#FFF" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
